import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, {
  ModalContent,
  ModalBodyText,
  ModalActions,
} from 'components/Modal';
import messages from './messages';

const ImportListItemDeleteConfirm = ({
  theme,
  onDismiss,
  showDeleteConfirmModal,
  handleDeleteIngestion,
  supportType,
}) => (
    <>
      <Modal
        title={intl.formatMessage(messages.deleteConfirmationTitle)}
        icon='warningCircle'
        iconColor={theme['color.redLight']}
        onDismiss={onDismiss}
        visible={showDeleteConfirmModal}
      >
        <ModalContent>
          <ModalBodyText>
            {supportType
              ? intl.formatMessage(
                messages.deleteConfirmImportingStatus
              )
              : intl.formatMessage(messages.deleteConfirmationDescription)}         
          </ModalBodyText>
        </ModalContent>
        <ModalActions>
          <Button grey onClick={onDismiss}>
            {intl.formatMessage(messages.cancel)}
          </Button>
          <Button
            primary
            color={theme['color.redDark']}
            onClick={handleDeleteIngestion}
          >
            {intl.formatMessage(messages.deleteImport)}
          </Button>
        </ModalActions>
      </Modal>
    </>
);

ImportListItemDeleteConfirm.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  showDeleteConfirmModal: PropTypes.bool,
  handleDeleteIngestion: PropTypes.func.isRequired,
};

export default withTheme(ImportListItemDeleteConfirm);
